import { useMemo } from 'react';
import { useTradeFormStore } from '../components/TradePage/TradeForm/TradeFormState';
import { calcPriceImpactBasedOnSize } from '../lib/orderbookHelpers';
import { useMarketLiquidity } from './useMarketLiquidityStore';

export const useMarketOrderPriceImpact = (
  productId: string | undefined,
  side: 'long' | 'short',
  size: bigint
) => {
  const { liquidityData } = useMarketLiquidity(productId);
  const result = calcPriceImpactBasedOnSize(liquidityData, side, size);
  const { enoughLiquidity } = result;
  const priceImpact = result.priceImpact;
  const midPrice = result.midPrice;
  const executionPrice = result.executionPrice;

  return useMemo(
    () => ({ executionPrice, priceImpact, midPrice, enoughLiquidity, isPending: !liquidityData }),
    [executionPrice, priceImpact, midPrice, enoughLiquidity, liquidityData]
  );
};

export const useEnoughLiquidity = (productId: string | undefined) => {
  const amount = useTradeFormStore((x) => x.amount);
  const side = useTradeFormStore((x) => x.side);
  const { enoughLiquidity, isPending } = useMarketOrderPriceImpact(productId, side, amount || 0n);
  return useMemo(() => ({ data: { enoughLiquidity }, isPending }), [enoughLiquidity, isPending]);
};
